import {
  collection,
  doc,
  type Firestore,
  type FirestoreDataConverter,
  type QueryDocumentSnapshot,
} from 'firebase/firestore'
import {
  convertDocumentSnapshotToModel,
  modelItemStream,
} from '../../firestore-mobx/stream'
import type { FirebaseRepository } from '../../models/FirebaseRepository'
import { SettingsDefaultProcessingAsset } from '../../models/SettingsDefaultProcessingAsset'
import type { FirestoreSettingsDefaultProcessingAsset } from './schema'
import { schema } from './schema'
import { getDocWithError, setDocWithError } from '../../firestore-mobx/fetch'

export * from './schema'

const converter: FirestoreDataConverter<FirestoreSettingsDefaultProcessingAsset> =
  {
    toFirestore: (data: FirestoreSettingsDefaultProcessingAsset) => data,
    fromFirestore: (snapshot: QueryDocumentSnapshot) => {
      return schema.parse(snapshot.data())
    },
  }

export const getDocRef = (firestore: Firestore) => {
  return doc(
    collection(firestore, 'settings').withConverter(converter),
    'default_processing_asset'
  )
}

export const fetchSettingsDefaultProcessingAsset = async (
  repository: FirebaseRepository
) => {
  const docRef = getDocRef(repository.firestore)

  const doc = await getDocWithError(
    docRef,
    'FetchSettingsDefaultProcessingAssetError'
  )

  return convertDocumentSnapshotToModel(
    repository,
    doc,
    SettingsDefaultProcessingAsset
  )
}

export const getSettingsDefaultProcessingAsset = (
  repository: FirebaseRepository
) => {
  const docRef = getDocRef(repository.firestore)

  return modelItemStream(repository, docRef, SettingsDefaultProcessingAsset)
}

export const setSettingsDefaultProcessingAsset = async (
  repository: FirebaseRepository,
  mediaId: string
) => {
  const docRef = getDocRef(repository.firestore)

  return setDocWithError(
    docRef,
    {
      mediaId,
    },
    { merge: true, errorName: 'SetSettingsDefaultProcessingAssetError' }
  )
}
